export function renderBalance(amount: number, side: "Dr" | "Cr", symbol = "") {
  const val = Math.abs(amount).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const withSymbol = symbol ? `${symbol} ${val}` : val;
  // Payable / credit → red brackets; otherwise black as before
  if (side === "Cr") {
    return <span className="text-rose-600 dark:text-rose-400 font-semibold">({withSymbol})</span>;
  }
  return <span className="tabular-nums font-semibold text-foreground">{withSymbol}</span>;
}

/** Signed movement: debit green, credit red — no brackets (brackets only on balance column). */
export function renderSignedAmount(amount: number, symbol = "") {
  if (Math.abs(amount) < 0.005) {
    return <span className="text-muted-foreground">—</span>;
  }
  const val = Math.abs(amount).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const withSymbol = symbol ? `${symbol} ${val}` : val;
  if (amount < 0) {
    return <span className="text-rose-600 dark:text-rose-400 font-medium tabular-nums">{withSymbol}</span>;
  }
  return <span className="text-emerald-600 dark:text-emerald-400 font-medium tabular-nums">{withSymbol}</span>;
}
